import { Validators } from '@angular/forms';
import { Currency } from '@models/currency';

import { Expense } from '@models/request';
import { StudyExpense } from '@models/study';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
import { MileageExpenseFormGroup } from '../mileage-expense-edit/mileage-expense-edit.form';
import { OtherExpenseFormGroup } from '../other-expense-edit/other-expense-edit.form';

export class ExpenseFormGroup extends PersistentFormGroup<{
    type: PersistentFormControl<StudyExpense>;
    file: PersistentFormControl<File>;
    mileageExpense: MileageExpenseFormGroup;
    otherExpense: OtherExpenseFormGroup;
    receiptDate: PersistentFormControl<Date>;
    currency: PersistentFormControl<Currency>;
    notes: PersistentFormControl<string>;
}> {
    constructor(public expense?: Expense) {
        super({
            type: new PersistentFormControl<StudyExpense>(null, [Validators.required]),
            file: new PersistentFormControl<File>(null),
            mileageExpense: new MileageExpenseFormGroup(),
            otherExpense: new OtherExpenseFormGroup(),
            receiptDate: new PersistentFormControl<Date>(null, [Validators.required]),
            currency: new PersistentFormControl<Currency>(null, [Validators.required]),
            notes: new PersistentFormControl<string>('', [maxLengthValidator(500), notWhitespaceValidator()]),
        });
    }
}
